import React from 'react';
import styled from 'styled-components';
import { DownloadOutlined, EditOutlined, CloseOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import { basicDataset } from '@mono/types/src/mds';
import { GetCfjsonResponse } from '@metservicedev/platforms-services-interface/src/services/movIntegrationMDS/MovIntegrationMDSModel';

import { ImportedWidgetblockContainer } from './ImportedWidgetblockContainer';
import { ItemButton } from './common/ItemButton';
import { IStage } from '@metservicedev/platforms-services-interface/src';
import { WidgetblockResponseModel } from '@metservicedev/platforms-services-interface/src/services/platformsWidgetblock/WidgetblockRequestModels';

const ItemContainer = styled.div`
    background-color: rgb(204, 204, 204);
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 16px;
    right: 16px;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    font-size: 24px;
`;

const ImportedWidgetblockEditorstyle = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .ItemContainer {
        display: none;
    }

    :hover {
        .ItemContainer {
            display: flex;
        }
    }
`;

interface ImportedWidgetblockEditorProps {
    onDelete: () => void;
    onToggleLock: () => void;
    onEdit: () => void;
    onStamp: () => void;
    date: string;
    weatherWidget?: WidgetblockResponseModel;
    isLocked: boolean;
    stage: IStage;
    timezone: string;
    datasets: basicDataset[];
    cfjsons: GetCfjsonResponse[];
    metjwt?: string;
}

export const ImportedWidgetblockEditor = (props: ImportedWidgetblockEditorProps) => {
    return (
        <ImportedWidgetblockEditorstyle>
            <ImportedWidgetblockContainer
                date={props.date}
                stage={props.stage}
                timezone={props.timezone}
                datasets={props.datasets}
                cfjsons={props.cfjsons}
                weatherWidget={props.weatherWidget}
                metjwt={props.metjwt}
            />
            <ItemContainer className='ItemContainer'>
                <ItemButton onClick={props.onToggleLock} IconProp={props.isLocked ? <LockOutlined /> : <UnlockOutlined />}></ItemButton>
                <ItemButton onClick={props.onStamp} IconProp={<DownloadOutlined />} />
                <ItemButton onClick={props.onEdit} IconProp={<EditOutlined />}></ItemButton>
                <ItemButton onClick={props.onDelete} IconProp={<CloseOutlined />}></ItemButton>
            </ItemContainer>
        </ImportedWidgetblockEditorstyle>
    );
};
